// extracted by mini-css-extract-plugin
module.exports = {"teaser":"_25fEvGCuGa_mAtVpciXQa7","container":"_2_u43uN_hFOL5SAuHy7CqP","reverse":"_2uU__lQ7_h6f7O7MXxcfb3","content":"_2SHwaG-JN2uyH9VBk8OThj"};